<div class="game-card">
  <img src="https://s3.gaming-cdn.com/images/products/2198/orig/hollow-knight-cover.jpg">

  <div class="game-card-content">
  </div>
</div>